import React from "react";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error("Uncaught error:", error, info);
    }

    handleReload = () => {
        this.setState({ hasError: false, error: null });
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen bg-background text-foreground flex items-center justify-center px-4 text-center">
                    <div>
                        <div className="font-mono text-xs uppercase tracking-[0.4em] text-red-500 mb-4">
                            ▌ RUNTIME ERROR
                        </div>
                        <h1 className="text-4xl font-black uppercase tracking-tighter mb-4">
                            Something broke
                        </h1>
                        <p className="text-zinc-400 mb-6 max-w-md mx-auto font-mono text-xs">
                            {this.state.error?.message || "An unexpected error occurred."}
                        </p>
                        <button
                            onClick={this.handleReload}
                            className="px-6 py-3 bg-primary text-primary-foreground font-bold uppercase tracking-wider hover:bg-[#33FFB0]"
                        >
                            Reload
                        </button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
